import {Component, Input, OnInit} from '@angular/core';
import {DossierIntervention} from 'app/models/dossier_intervention.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UserService as AuthUserService} from '../../../core/user/user.service';
import {DossierInterventionService} from '../../../services/dossier_intervention.service';
import {UserService} from '../../../services/user.service';
import {Etage} from '../../../models/etage.model';
import {ActiviteAssechement} from '../../../models/activiteAssechement.model';
import {ModalActiviteAssechementComponent} from './modal-activite-assechement.component';
import {Piece} from '../../../models/piece.model';
import { User } from 'app/models/user.model';
import {forEach, join, map} from 'lodash-es';
import {
    DossierInterventionActiviteAssechementModel
} from '../../../models/dossierInterventionActiviteAssechement.model';
import {ActiviteEau} from '../../../models/activiteEau.model';
import {ModalActiviteEauComponent} from './modal-activite-eau.component';
import {DossierInterventionActiviteEau} from '../../../models/dossierInterventionActiviteEau.model';
import html2pdf from 'html2pdf.js';

@Component({
    selector: 'app-dossier-rapport-psychometrique',
    templateUrl: './dossier-rapport-psychometrique.component.html',
    styleUrls: ['./dossier-rapport-psychometrique.component.scss']
})
export class DossierRapportPsychometriqueComponent implements OnInit {
    @Input() currentDossierIntervention: DossierIntervention;
    activitesAssechements: ActiviteAssechement[] = [];
    formatedActivitesAssechements: object[] = [];

    activitesEaux: ActiviteEau[] = [];
    formatedActivitesEaux: object[] = [];

    pieces: Piece[] = [];
    etages: Etage[] = [];
    techniciens: User[];
    surfaces: string[] = [];

    openChevron = [];
    materials: string[] = [];
    isGeneratingPDF = false;

    constructor(
        private authUserService: AuthUserService,
        private userService: UserService,
        private dossierInterventionService: DossierInterventionService,
        private dialog: MatDialog,

    ) {
    }

    get isAdmin(): boolean {
        return this.authUserService.getCurrentUser().role_id === 1;
    }

    ngOnInit(): void {
        this.getAll();
    }

    getAll(): void {
        this.getActiviteAssechements();
        this.getActiviteEaux();
        this.fetchPieces();
        this.fetchEtages();
        this.fetchTechniciens();
        this.fetchSurfaces();
        this.fetchMaterials();
    }

    fetchPieces(): void {
        this.dossierInterventionService.getPiecesForDossierIntervention(this.currentDossierIntervention.id).subscribe((pieces) => {
            this.pieces = pieces;
        });
    }

    fetchEtages(): void {
        this.dossierInterventionService.getEtagesForDossierIntervention(this.currentDossierIntervention.id).subscribe((etages) => {
            this.etages = etages;
        });
    }

    fetchTechniciens(): void {
        this.userService.getUsers().subscribe((techniciens) => {
            this.techniciens = techniciens;
        });
    }

    fetchSurfaces(): void {
        this.dossierInterventionService.getSurfacesForDossierIntervention(this.currentDossierIntervention.id).subscribe((surfaces) => {
            this.surfaces = surfaces;
        });
    }
    fetchMaterials(): void {
        this.dossierInterventionService.getMaterialsForDossierIntervention(this.currentDossierIntervention.id).subscribe((materials) => {
            this.materials = materials;
        });
    }

    getActiviteAssechements(): void {
        this.dossierInterventionService.getActiviteAssechementsForDossierIntervention(this.currentDossierIntervention.id).subscribe((result) => {
            this.activitesAssechements = result;
            const formattedActivites = {};
            forEach(result, (activite: ActiviteAssechement) => {
                const key = join([
                    activite.dossier_intervention_activite_assechement.etage_id,
                    activite.dossier_intervention_activite_assechement.piece_id,
                    activite.dossier_intervention_activite_assechement.surface,
                    activite.dossier_intervention_activite_assechement.material
                ], '|');

                if (typeof formattedActivites[key] === 'undefined') {
                    formattedActivites[key] = {
                        'childrens' : [],
                        'etage_id' : activite.dossier_intervention_activite_assechement.etage_id,
                        'piece_id' : activite.dossier_intervention_activite_assechement.piece_id,
                        'surface' : activite.dossier_intervention_activite_assechement.surface,
                        'material' : activite.dossier_intervention_activite_assechement.material,
                        'standard' : activite.dossier_intervention_activite_assechement.standard,
                        'last_report': activite.visit_date
                    };
                }

                formattedActivites[key]['childrens'].push(new ActiviteAssechement(activite));

                if (Date.parse(activite.visit_date) > Date.parse(formattedActivites[key]['last_report'])) {
                    formattedActivites[key]['last_report'] = Date.parse(activite.visit_date);
                }
            });
            this.formatedActivitesAssechements = [];
            forEach(formattedActivites, (value) => {
                this.formatedActivitesAssechements.push(value);
            });
        });
    }
    getActiviteEaux(): void {
        this.dossierInterventionService.getActiviteEauxForDossierIntervention(this.currentDossierIntervention.id).subscribe((result) => {
            this.activitesEaux = result;
            const formattedActivites = {};
            forEach(result, (activite: ActiviteEau) => {
                const key = join([
                    activite.dossier_intervention_activite_eau.etage_id ?? 'EXTERIEUR',
                    activite.dossier_intervention_activite_eau.piece_id ?? 'EXTERIEUR',
                ], '|');

                if (typeof formattedActivites[key] === 'undefined') {
                    formattedActivites[key] = {
                        'childrens' : [],
                        'etage_id' : activite.dossier_intervention_activite_eau.etage_id,
                        'piece_id' : activite.dossier_intervention_activite_eau.piece_id,
                        'last_report': activite.visit_date
                    };
                }

                formattedActivites[key]['childrens'].push(new ActiviteEau(activite));

                if (Date.parse(activite.visit_date) > Date.parse(formattedActivites[key]['last_report'])) {
                    formattedActivites[key]['last_report'] = Date.parse(activite.visit_date);
                }
            });
            this.formatedActivitesEaux = [];
            forEach(formattedActivites, (value) => {
                this.formatedActivitesEaux.push(value);
            });
        });
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    openActiviteAssechementModal(activiteAssechement = null, isEditing = false): MatDialogRef<ModalActiviteAssechementComponent> {
        const dialogRef = this.dialog.open(ModalActiviteAssechementComponent, {
            width: '75%',
        });

        if (!activiteAssechement) {
            activiteAssechement = new ActiviteAssechement({
                dossier_intervention_activite_assechement: new DossierInterventionActiviteAssechementModel({
                    dossier_intervention_id: this.currentDossierIntervention.id,
                }),
            });
            dialogRef.componentInstance.activiteAssechement = activiteAssechement;
        } else {
            if (isEditing) {
                dialogRef.componentInstance.activiteAssechement = activiteAssechement;
            } else {
                activiteAssechement.childrens[0].id = null;
                dialogRef.componentInstance.activiteAssechement = activiteAssechement.childrens[0];
                dialogRef.componentInstance.activiteAssechement.visit_date = new Date().toISOString().split('T')[0];
                dialogRef.componentInstance.activiteAssechement.humidity = null;
            }
        }

        dialogRef.componentInstance.activitesAssechements = this.activitesAssechements;
        dialogRef.componentInstance.etages = this.etages;
        dialogRef.componentInstance.pieces = this.pieces;
        dialogRef.componentInstance.techniciens = this.techniciens;
        dialogRef.componentInstance.surfaces = this.surfaces;
        dialogRef.componentInstance.materials = this.materials;

        dialogRef.afterClosed().subscribe((result) => {
            this.getActiviteAssechements();
        });

        return dialogRef;
    }

    getEtageNom(etage_id: number): string {
        const etage: Etage = this.etages.find((e: Etage) => e.id === etage_id);
        return etage ? etage.nom_niveau : '';
    }

    getPieceNom(piece_id: number): string {
        const piece: Piece = this.pieces.find((p: Piece) => p.id == piece_id);
        return piece ? piece.nom_piece : '';
    }

    toggleChevron(index: any): void {
        if (this.chevronIsOpen(index)) {
            delete this.openChevron[index];
        } else {
            this.openChevron[index] = true;
        }
    }

    chevronIsOpen(index: number): boolean {
        return typeof this.openChevron[index] !== 'undefined';
    }

    getTechnicienName(technicien_id: any) {
        const technicien: User = this.techniciens.find((t: User) => t.id === technicien_id);
        return technicien ? technicien.prenom + ' ' + technicien.nom : '';
    }

    openActiviteEauModal(activiteEau: ActiviteEau = null): MatDialogRef<ModalActiviteEauComponent> {
        const dialogRef = this.dialog.open(ModalActiviteEauComponent, {
            width: '75%',
        });

        if (!activiteEau) {
            activiteEau = new ActiviteEau({
                dossier_intervention_activite_eau: new DossierInterventionActiviteEau({
                    dossier_intervention_id: this.currentDossierIntervention.id,
                })
            });
        }

        dialogRef.componentInstance.activiteEau = activiteEau;
        dialogRef.componentInstance.activitesEaux = this.activitesEaux;
        dialogRef.componentInstance.etages = this.etages;
        dialogRef.componentInstance.pieces = this.pieces;

        dialogRef.afterClosed().subscribe((result) => {
            this.getActiviteEaux();
        });

        return dialogRef;
    }

    generatePDF() {
        this.isGeneratingPDF = true;
    
        setTimeout(() => {
            const element = document.getElementById("capture-pdf");
            const clone = element.cloneNode(true) as HTMLElement;
    
            this.hideElements(clone);

            const elementsBorderTop = clone.querySelectorAll('.border-top-pdf');
            elementsBorderTop.forEach((element: HTMLElement) => element.style.width = "95%");
            elementsBorderTop.forEach((element: HTMLElement) => element.style.borderTop = "solid 2px black");
    
            setTimeout(() => {
                const options = {
                    filename: "rapport.pdf",
                    image: { type: "jpeg", quality: 0.98 },
                    html2canvas: { scale: 4 },
                    jsPDF: { unit: "mm", format: "a4", orientation: "portrait", title: "Rapport psychométrique" },
                };
    
                html2pdf()
                    .from(clone)
                    .set(options)
                    .toPdf()
                    .get("pdf")
                    .then((pdf) => {
                        const pdfBlob = pdf.output("blob");
                        const pdfUrl = URL.createObjectURL(pdfBlob);
                        window.open(pdfUrl, "_blank");

                        this.isGeneratingPDF = false;
                    });
            }, 0);
        }, 0);
    }
    
    hideElements(clone: HTMLElement) {
        const elementsToHide = clone.querySelectorAll('.hide-in-pdf');
        const elementsEtage = clone.querySelectorAll('.etage');
        elementsToHide.forEach((element: HTMLElement) => element.setAttribute('class', 'hidden'));
        elementsEtage.forEach((element: HTMLElement) => element.setAttribute('class', 'capitalize ml-11'));
    }
}
